# graphql/queries/hifo/GetHifos.graphql
query GetHifos(
  $page: Int!
  $limit: Int!
  $statuses: [HifoStatus!]
  $hifoTypes: [HifoTypeEnum!]
  $search: String
  $sortBy: String
) {
  hifos(
    page: $page
    limit: $limit
    statuses: $statuses
    hifoTypes: $hifoTypes
    search: $search
    sortBy: $sortBy
  ) {
    collection {
      id
      status
      name
      audience
      hifoType
      expiryDate
      primaryCauseArea
      charityCategories {
        id
      }
      researcherRelationship {
        id
        name
      }
      roomForFunding {
        currency
        minorUnit
      }
      minDonationAmount {
        currency
        minorUnit
      }
      createdBy {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
